import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { merge, Subject } from 'rxjs';
import { debounceTime, filter, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';
import { RecurrenceService } from 'app/main/recurrences/services/recurrence.service';
var TabOccurrencesComponent = /** @class */ (function () {
    function TabOccurrencesComponent(dialogData, fuseProgressBarService, recurrenceService) {
        this.dialogData = dialogData;
        this.fuseProgressBarService = fuseProgressBarService;
        this.recurrenceService = recurrenceService;
        this.resultsLength = 0;
        this.occurrences = [];
        this.subscriptions = new Subject();
        this.reload = new EventEmitter();
        this.displayedColumns = ['scheduledDate', 'number', 'company', 'status'];
        this.isLoading = true;
        this.recurrence = this.dialogData.recurrence;
        this.query = {
            recurrenceId_in: [this.recurrence.id]
        };
    }
    TabOccurrencesComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    TabOccurrencesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sort.active = 'scheduledDate';
        this.sort.direction = 'desc';
        merge(this.sort.sortChange, this.paginator.page, this.reload.pipe(tap(function () { return _this.paginator.firstPage(); })))
            .pipe(takeUntil(this.subscriptions), startWith({}), filter(function () { return !!_this.recurrence.id; }), debounceTime(500), switchMap(function () {
            _this.isLoading = true;
            _this.fuseProgressBarService.show();
            return _this.searchOccurrences();
        }))
            .subscribe(function (data) {
            _this.fuseProgressBarService.hide();
            _this.resultsLength = data.totalCount;
            _this.occurrences = data.items;
            _this.isLoading = false;
        });
    };
    TabOccurrencesComponent.prototype.searchOccurrences = function () {
        return this.recurrenceService.listOccurrences({
            where: this.query,
            options: {
                offset: this.paginator.pageIndex * this.paginator.pageSize,
                limit: this.paginator.pageSize,
                orderBy: this.sort.active + "_" + this.sort.direction
            },
        });
    };
    return TabOccurrencesComponent;
}());
export { TabOccurrencesComponent };
